export default "__VITE_ASSET__ece750c0__"